<app-container>
  <div class='grid gap-lg auto-rows-auto'>
    <div>
      <h1 class='text-gray-800 font-light'>Style Guide</h1>
    </div>
    <div>
      <h3 class='font-thin'>Typography</h3>
      <h1 class='text-gray-800'>Heading 1</h1>
      <h2 class='text-gray-700'>Heading 2</h2>
      <h3 class='text-gray-700'>Heading 3</h3>
      <h4 class='text-gray-700'>Heading 4</h4>
      <h5 class='text-gray-700'>Heading 5</h5>
      <h6 class='text-gray-700'>Heading 6</h6>
      <p class='text-gray-900'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
        has been the industry's
        standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make
        a
        type specimen book.
      </p>
      <p>
        It has survived not only five centuries, but also the leap into electronic typesetting,
        remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing
        Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions
        of
        Lorem Ipsum.</p>
      <p class='small text-gray-500'>Small</p>
      <a href='#'>Link</a>
    </div>
    <div>
      <h3 class='font-thin'>Buttons</h3>
      <div class='space-x-sm'>
        <button class='btn btn-primary'>Primary Button</button>
        <button class='btn btn-secondary'>Secondary Button</button>
        <button class='btn btn-link'>Link</button>
      </div>
    </div>
    <div>
      <h3 class='font-thin'>Forms</h3>
      <form action=''>

      <app-textfield label='Text Input' placeholder='Text Input'></app-textfield>

      <app-dropdown label='Input' [options]='[{label: "hello", value: "hello"},{label: "hello 2", value: "hello2"},]' [formControl]='fc'></app-dropdown>

<!--      <mat-form-field appearance='outline' class='w-full'>-->
        <mat-select>
          <mat-option value='option1'>Option 1</mat-option>
          <mat-option value='option2'>Option 2 (disabled)</mat-option>
          <mat-option value='option3'>Option 3</mat-option>
        </mat-select>
<!--      </mat-form-field>-->
      </form>
    </div>

<!--    <div>-->
<!--      <h3 class='font-thin'>Login Form</h3>-->
<!--      <div class='w-full max-w-xs'>-->
<!--        <form class='bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4'>-->
<!--          <div class='mb-4'>-->
<!--            <label class='block text-gray-700 text-sm font-bold mb-2' for='username'>-->
<!--              Username-->
<!--            </label>-->
<!--            <input-->
<!--              class='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'-->
<!--              id='username' type='text' placeholder='Username'>-->
<!--          </div>-->
<!--          <div class='mb-6'>-->
<!--            <label class='block text-gray-700 text-sm font-bold mb-2' for='password'>-->
<!--              Password-->
<!--            </label>-->
<!--            <input-->
<!--              class='shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline'-->
<!--              id='password' type='password' placeholder='******************'>-->
<!--            <p class='text-red-500 text-xs italic'>Please choose a password.</p>-->
<!--          </div>-->
<!--          <div class='flex items-center justify-between'>-->
<!--            <button-->
<!--              class='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'-->
<!--              type='button'>-->
<!--              Sign In-->
<!--            </button>-->
<!--            <a class='inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800' href='#'>-->
<!--              Forgot Password?-->
<!--            </a>-->
<!--          </div>-->
<!--        </form>-->
<!--        <p class='text-center text-gray-500 text-xs'>-->
<!--          &copy;2020 Acme Corp. All rights reserved.-->
<!--        </p>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</app-container>
